import { Column } from "../objects/column";
import { Purchase } from "../objects/purchase";
import { PurchaseErrors } from "../objects/purchaseErrors";
import { PurchaseListConfiguration } from "../objects/purchaseListConfiguration";
import { PurchaseListCriteria } from "../objects/purchaseListCriteria";
import { PurchaseListFiltersCriteria } from "../objects/purchaseListFiltersCriteria";

export const EMPTY_PURCHASE: Purchase = {
    id: 0,
    owner: {
        id: 0,
        name: "",
        type: 0,
        logo: null,
        logo_minimal: null,
        phone_number: null,
        street: null,
        zip_code: null,
        city: null
    },
    invoice_date: null,
    export_date: null,
    payment_limit_date: null,
    account_number: 0,
    counterpart_account_number: null,
    invoice_number: null,
    credit_note_number: null,
    is_automatic: false,
    is_reversal: false,
    is_counterpart: false,
    is_reversed: false,
    is_cancel: false,
    is_sale: false,
    is_payment: false,
    margin_tva: false,
    action: "",
    additional_info: undefined,
    product_booking_date: null,
    product_start_date: null,
    product_type: 0,
    provider_code: null,
    product_description: null,
    product_booking_ref: null,
    origin_amount: "",
    amount: "",
    factor_used: "",
    custom_rate: null,
    is_sent: false,
    trip: 0,
    trip_version: null,
    provider: null,
    origin_currency: null,
    currency: null,
    products: [],
    parent: [],
    created_date: undefined,
    modified_date: undefined,
    creator: null,
    last_author: null
};

export const EMPTY_PURCHASE_FILTERS: PurchaseListFiltersCriteria = {
    name: '',
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    bic: "",
    iban: "",
    period: "MODIFICATION",
};

export const EMPTY_PURCHASE_LIST_CRITERIA: PurchaseListCriteria = {
    limit: 100,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_PURCHASE_FILTERS,
    search: ''
};

export const EMPTY_PURCHASE_ERRORS: PurchaseErrors = {
    name_error: '',
    iban_error: '',
    bic_error: '',
    due_date_error: ""
};

export const PURCHASE_INFO_ROUTE = '/central-payment/edit/:id/info';
export const PURCHASE_CONTACT_ROUTE = '/central-payment/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'iban',
    field_name: 'IBAN',
    checked: true,
    order_by: 'iban',
    fixed_width: false,
    last_updated: false
},
{
    label: 'bic',
    field_name: 'BIC',
    checked: true,
    order_by: 'bic',
    fixed_width: false,
    last_updated: false
},
{
    label: 'is-commission-applied',
    field_name: 'IS_COMMISSION_APPLIED',
    checked: true,
    order_by: 'is_commission_applied',
    fixed_width: false,
    last_updated: false
},
{
    label: 'commission-percentage',
    field_name: 'COMMISSION_PERCENTAGE',
    checked: true,
    order_by: 'commission_percentage',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false
}];

export const EMPTY_PURCHASE_LIST_CONFIGURATION: PurchaseListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const PURCHASE_MODULE = 'CENTRAL_PAYMENT';
